import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2h2v2h8V2h2v2h1a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h1V2zm-1 8h14v8H5v-8z" }));
export default createSvgIcon(iconPath, "Calendar");
//# sourceMappingURL=CalendarIcon.js.map